module.exports = __webpack_public_path__ + "soak-testing.2r6OJfP1.svg";